// import { styled } from "@mui/material/styles";
// import LinearProgress from "@mui/material/LinearProgress";

// const shouldForwardProp = (prop) => prop !== "ownerState";
// export default styled(LinearProgress)(({ theme, ownerState }) => {
//   const { palette, functions } = theme;
//   const { color, value, variant } = ownerState;

//   const { text, gradients } = palette;
//   const { linearGradient } = functions;

//   // background value
//   let backgroundValue;

//   if (variant === "gradient") {
//     backgroundValue = gradients[color]
//       ? linearGradient(gradients[color].main, gradients[color].state)
//       : linearGradient(gradients.info.main, gradients.info.state);
//   } else {
//     backgroundValue = palette[color] ? palette[color].main : palette.info.main;
//   }

//   return {
//     "& .MuiLinearProgress-bar": {
//       background: backgroundValue,
//       width: `${value >= 100 ? 100 : value}%`,
//       color: text.main,
//     },
//   };
// });

import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";

const shouldForwardProp = (prop) => prop !== "ownerState";
export default styled(LinearProgress, { shouldForwardProp })(({ theme, ownerState = {} }) => {
  const { palette, functions } = theme || {};
  const { color = "info", value = 0, variant = "contained" } = ownerState;

  const gradients = palette?.gradients || {};
  const linearGradient =
    functions?.linearGradient ||
    ((a, b) => `linear-gradient(${a}, ${b})`);

  const textMain = palette?.text?.main || "#000";
  let backgroundValue;

  if (variant === "gradient") {
    if (gradients[color]) {
      backgroundValue = linearGradient(gradients[color].main, gradients[color].state);
    } else if (gradients.info) {
      backgroundValue = linearGradient(gradients.info.main, gradients.info.state);
    } else {
      backgroundValue = palette?.[color]?.main || palette?.info?.main || "#1976d2";
    }
  } else {
    backgroundValue = palette?.[color]?.main || palette?.info?.main || "#1976d2";
  }

  return {
    "& .MuiLinearProgress-bar": {
      background: backgroundValue,
      width: `${Math.min(Number(value) || 0, 100)}%`,
      color: textMain,
    },
  };
});
